/* This file is autogenerated, see readme.md for instructions */
import VariantsSvgIcon from '@bloomreach/banana-theme/icons/variants.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const VariantsIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <VariantsSvgIcon />
    </Icon>
  );
});

VariantsIcon.displayName = 'VariantsIcon';

export default VariantsIcon;
